import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import Breadcrumb from 'react-bootstrap/Breadcrumb'
 
 
class OpenLoopLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      selectedOption: "",
    };
    this.toggle = this.toggle.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }
 
  toggle(tab) {
    this.setState((prevState) => {
      return {
        ...prevState,
        activeTab: tab,
      };
    });
  }
  handleRadioChange(event) {
    if (event.target.checked && event.target.value === "camera") {
      this.setState(() => ({ selectedOption: "camera" }));
    } else if (event.target.checked && event.target.value === "lidar") {
      this.setState(() => ({ selectedOption: "lidar" }));
    } else if (event.target.checked && event.target.value === "radar") {
      this.setState(() => ({ selectedOption: "radar" }));
    }
 
    //<<<<<<< HEAD
    //   this.setState({
    //      selectedOption: event.target.value
    //=======
    this.setState({
      selectedOption: event.target.value,
      //>>>>>>> 2c1e3837e670b12a5c0bb5f5e5797276c5125de7
    });
  }
  // class OpenLoopLanding extends Component{
  //     constructor(props){
  //       super(props)
  //       this.state = {
  //           activeTab : '1',
  //           selectedOption: ''
 
  //       }
  //       this.toggle = this.toggle.bind(this);
  //       this.handleRadioChange = this.handleRadioChange.bind(this);
  //     }
 
  //     toggle(tab) {
  //       this.setState( (prevState) => {
  //           return {
  //               activeTab: tab
  //           }
  //       })
  //     }
  //     handleRadioChange(event) {
  //       if (event.target.checked && event.target.value === "camera") {
  //               this.setState(() => ({selectedOption: 'camera'}));
 
  //       }else if (event.target.checked && event.target.value === "lidar"){
  //           this.setState(() => ({selectedOption: 'lidar'}));
 
  //       }else if (event.target.checked && event.target.value === "radar"){
  //       this.setState(() => ({selectedOption: 'radar'}));
 
  //       }
 
  //   //<<<<<<< HEAD
  //   //  this.setState({
  //   //      selectedOption: event.target.value
  //   //=======
  //        this.setState({
  //            selectedOption: event.target.value
  //   //>>>>>>> 2c1e3837e670b12a5c0bb5f5e5797276c5125de7
  //       });
 
  //   }
 
  render() {
    const selectedOption = this.state.selectedOption;
    var check;
    if (selectedOption === "camera") {
      check = (
        <Link to="/camera">
          <h4
            style={{
              textAlign: "center",
              fontSize: "1.8rem",
              fontWeight: "900",
              color: "#622AD8",
            }}
          >
            KPI Selector
          </h4>
        </Link>
      );
    } else if (selectedOption === "lidar") {
      check = (
        <Link to="/lidar">
          <h4
            style={{
              textAlign: "center",
              fontSize: "1.8rem",
              fontWeight: "900",
              color: "#622AD8",
            }}
          >
            KPI Selector
          </h4>
        </Link>
      );
    } else if (selectedOption === "radar") {
      check = (
        <Link to="/radar">
          <h4
            style={{
              textAlign: "center",
              fontSize: "1.8rem",
              fontWeight: "900",
              color: "#622AD8",
            }}
          >
            KPI Selector
          </h4>
        </Link>
      );
    } else {
      check = (
        <Link to="/kpi_manager" style={{ textDecoration: "none" }}>
          <h4
            style={{
              textAlign: "center",
              fontSize: "1.8rem",
              fontWeight: "900",
              color: "#622AD8",
            }}
          >
            KPI Selector
          </h4>
        </Link>
      );
    }
    return (
      <div data-test="openLoopLandingComponent">
        <Breadcrumb>
          <Breadcrumb.Item href="">
            <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to='/welcome'>Welcome</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/open_loop" active> Open loop</Breadcrumb.Item>
        </Breadcrumb>
        <div className="container" style={{ paddingTop: "5%" }}>
          <div className="card">
            <div
              className="card-header"
              style={{ backgroundColor: "#757AF7", color: "white" }}
            >
              <h1>Open Loop</h1>
            </div>
            <div className="card-body">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "1",
                          })}
                          onClick={() => {
                            this.toggle("1");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Sensor
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTab === "2",
                          })}
                          onClick={() => {
                            this.toggle("2");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Components
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <div className="row" style={{ paddingTop: "2%" }}>
                          <div className="col-md-12">
                            <div className="card">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-4">
                                    <input
                                      type="radio"
                                      value="camera"
                                      name="sensor"
                                      checked={
                                        this.state.selectedOption === "camera"
                                      }
                                      onChange={this.handleRadioChange}
                                    />
                                    <label
                                      htmlFor="camera"
                                      style={{ paddingLeft: "2%" }}
                                    >
                                      Camera
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <input
                                      type="radio"
                                      value="lidar"
                                      name="sensor"
                                      checked={
                                        this.state.selectedOption === "lidar"
                                      }
                                      onChange={this.handleRadioChange}
                                    />
                                    <label
                                      htmlFor="lidar"
                                      style={{ paddingLeft: "2%" }}
                                    >
                                      LiDar
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <input
                                      type="radio"
                                      value="radar"
                                      name="sensor"
                                      checked={
                                        this.state.selectedOption === "radar"
                                      }
                                      onChange={this.handleRadioChange}
                                    />
                                    <label
                                      htmlFor="radar"
                                      style={{ paddingLeft: "2%" }}
                                    >
                                      Radar
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane tabId="2">
                        <div className="row" style={{ paddingTop: "2%" }}>
                          <div className="col-md-12">
                            <div className="card">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-4">
                                    <input
                                      type="radio"
                                      id="perception"
                                      name="component"
                                    />
                                    <label
                                      htmlFor="perception"
                                      style={{ paddingLeft: "2%" }}
                                    >
                                      Perception
                                    </label>
                                  </div>
                                  <div className="col-md-4">
                                    <input
                                      type="radio"
                                      id="decision_system"
                                      name="component"
                                    />
                                    <label
                                      htmlFor="decision_system"
                                      style={{ paddingLeft: "2%" }}
                                    >
                                      Decision System
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
                <div className="row" style={{ paddingTop: "2%" }}>
                  <div className="col-6">
                    <div className="card">
                      <div
                        className="card-body align-items-center"
                        style={{ height: "100%" }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            fontSize: "1.8rem",
                            fontWeight: "bold",
                            color: "#622AD8",
                          }}
                        >
                          Data Pipeline
                        </h4>
                        <div className="row">
                          <div className="col-md-6">
                            <Link
                              to="/k-data_analyzer"
                              style={{ textDecoration: "none", color: "black" }}
                            >
                              <div className="card" id="info-box">
                                <div className="card-body align-items-center d-flex justify-content-center">
                                  K-Data Analyzer
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="card" id="info-box">
                                  <div className="card-body align-items-center d-flex justify-content-center">
                                    Search
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row" style={{ paddingTop: "2%" }}>
                              <div className="col-md-12">
                                <div className="card" id="info-box">
                                  <div className="card-body align-items-center d-flex justify-content-center">
                                    Anomaly
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ paddingTop: "2%" }}>
                          <div className="col-md-6">
                            <div className="card" id="info-box">
                              <div className="card-body align-items-center d-flex justify-content-center">
                                Manage Data
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="card" id="info-box">
                                  <div className="card-body align-items-center d-flex justify-content-center">
                                    Trend
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row" style={{ paddingTop: "2%" }}>
                              <div className="col-md-12">
                                <div className="card" id="info-box">
                                  <div className="card-body align-items-center d-flex justify-content-center">
                                    Data Down Selection
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row">
                      <div className="col-md-12">
                        <Link
                          to="/view_scenario"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                Scenario Selector
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2%" }}>
                      <div className="col-md-12">
                        <Link
                          to="/kpi_manager"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                {check}
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
 
                    <div className="row" style={{ paddingTop: "2%" }}>
                      <div className="col-md-12">
                        <Link
                          to="/upload_file"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                Scheduler
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2%" }}>
                      <div className="col-md-12">
                        <Link
                          to="/welcomeautomatekpi/landingkpidashboard"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                KPI Dashboard
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2%" }}>
                      <div className="col-md-12">
                        <Link
                          to="/open_loop/fusion_data_listing"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                Fusion Data Listing
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: "2%" }}>
                      <div className="col-md-12">
                        <Link
                          to="/reporting"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="card" id="info-box">
                            <div className="card-body">
                              <h4
                                style={{
                                  textAlign: "center",
                                  fontSize: "1.8rem",
                                  fontWeight: "900",
                                  color: "#622AD8",
                                }}
                              >
                                Reporting
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default OpenLoopLanding;